import OrderDetailInfoRow from '@/components/OrdersModule/OrderDetail/Header/OrderDetailInfoRow'
import { ColorEnum } from '@/constants/color'
import { DeliveryTime } from '@/features/orders/types/app'
import ClockIcon from '@/features/ui/icons/components/ClockIcon'
import LocationIcon from '@/features/ui/icons/components/LocationIcon'
import MobileIcon from '@/features/ui/icons/components/MobileIcon'
import MoneyIcon from '@/features/ui/icons/components/MoneyIcon'
import NoteIcon from '@/features/ui/icons/components/NoteIcon'
import { formatDeliveryTime } from '@/utils/formatDeliveryTime'
import { FC } from 'react'
import { View } from 'react-native'

interface OrderInfoProps {
    deliveryTime?: DeliveryTime
    phoneNumber?: string
    address?: string
    paymentType?: string
    customerNote?: string
}

const OrderInfo: FC<OrderInfoProps> = ({
    deliveryTime,
    phoneNumber,
    address,
    paymentType,
    customerNote,
}) => {
    return (
        <View style={{ gap: 8 }}>
            {deliveryTime && (
                <OrderDetailInfoRow bold Icon={ClockIcon}>
                    {formatDeliveryTime(deliveryTime)}
                </OrderDetailInfoRow>
            )}
            {phoneNumber && (
                <OrderDetailInfoRow Icon={MobileIcon}>{phoneNumber}</OrderDetailInfoRow>
            )}
            {address && (
                <OrderDetailInfoRow
                    Icon={(props) => (
                        <LocationIcon
                            {...props}
                            color={ColorEnum.EMERALD_500}
                            height={16}
                            width={16}
                        />
                    )}
                >
                    {address}
                </OrderDetailInfoRow>
            )}
            {paymentType && (
                <OrderDetailInfoRow Icon={() => <MoneyIcon color={ColorEnum.EMERALD_500} />}>
                    {paymentType}
                </OrderDetailInfoRow>
            )}
            {customerNote && (
                <OrderDetailInfoRow Icon={NoteIcon}>{customerNote}</OrderDetailInfoRow>
            )}
        </View>
    )
}

export default OrderInfo
